import React from 'react';

interface LocationIconProps {
	className?: string;
	size?: 'small' | 'medium' | 'large';
}

const LocationIcon = ({ className, size = 'large', ...props }: LocationIconProps) => (
	<svg
		{...props}
		width={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
		height={size === 'small' ? '16' : size === 'medium' ? '20' : '24'}
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		className={className}
		style={{
			minWidth: size === 'small' ? '16' : size === 'medium' ? '20' : '24',
			minHeight: size === 'small' ? '16' : size === 'medium' ? '20' : '24',
		}}
	>
		<path
			d="M16.8188 4.99501C15.54 3.71859 13.8069 3.00171 12.0001 3.00171C10.1932 3.00171 8.46019 3.71859 7.18133 4.99501C6.02046 6.1549 5.3172 7.69477 5.20077 9.33167C5.08435 10.9686 5.56255 12.5925 6.54756 13.905L11.6036 20.4841C11.8038 20.7446 12.1964 20.7446 12.3965 20.4841L17.4526 13.905C18.4376 12.5925 18.9158 10.9686 18.7994 9.33167C18.6829 7.69477 17.9797 6.1549 16.8188 4.99501ZM12.0001 12.1763C11.5551 12.1763 11.1201 12.0443 10.7501 11.7971C10.38 11.5498 10.0916 11.1984 9.92133 10.7873C9.75103 10.3762 9.70647 9.92376 9.79329 9.4873C9.88011 9.05085 10.0944 8.64993 10.4091 8.33526C10.7237 8.02059 11.1247 7.80631 11.5611 7.71949C11.9976 7.63267 12.45 7.67723 12.8611 7.84753C13.2723 8.01782 13.6236 8.30621 13.8709 8.67622C14.1181 9.04623 14.2501 9.48125 14.2501 9.92625C14.2501 10.523 14.013 11.0953 13.5911 11.5172C13.1691 11.9392 12.5968 12.1763 12.0001 12.1763Z"
			fill="currentColor"
		/>
	</svg>
)

export default LocationIcon
